<template>
  <div class="d-flex flex-nowrap">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabNav",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
};
</script>
